export const GET_COLLECTION = '/transactions'
export const TRANSACTIONS = '/transactions'